<script setup lang="ts">
import { recordPageList } from '@mp/api/sdpMessage/MessageV2Controller.js'
import Item from './Item.vue'
import { onMounted, onUnmounted, reactive, ref } from 'vue'
import WujieVue from 'wujie-vue3'

const { bus } = WujieVue

const finished = ref<boolean>(false)
const loading = ref<boolean>(false)
const list = ref<APISdpMessage.MessageRecordDto[]>([])
let requestSeq = 0

const params = reactive<{
  queryType: APISdpMessage.QueryCursorMessageRecordRequest['queryType']
  targetAppId: APISdpMessage.QueryCursorMessageRecordRequest['targetAppId']
  messageType: string
}>({
  queryType: 'ALL',
  targetAppId: 'WEB_B',
  messageType: 'todo_task',
})

const pager = reactive<{
  pageNum: number
  pageSize: number
  total: number
}>({
  pageNum: 1,
  pageSize: 20,
  total: 0,
})

async function handleGetDatas(reset = false) {
  // 滚动加载中忽略重复触发；筛选重置允许覆盖进行中的请求
  if (loading.value && !reset)
    return

  if (reset) {
    pager.pageNum = 1
    list.value = []
    finished.value = false
  }

  const seq = ++requestSeq
  const queryType = params.queryType
  loading.value = true

  try {
    const { series, totalCount } = await recordPageList({
      pageNum: pager.pageNum,
      pageSize: pager.pageSize,
      ...params,
      queryType,
    })

    // 丢弃过期请求（切换筛选后旧响应回来）
    if (seq !== requestSeq)
      return

    if (!totalCount) {
      finished.value = true
      return
    }

    pager.pageNum += 1
    pager.total = totalCount || 0
    list.value.push(...(series || []))

    if (list.value.length >= totalCount)
      finished.value = true
  }
  finally {
    if (seq === requestSeq)
      loading.value = false
  }
}

function handleQueryTypeChange(queryType: typeof params.queryType) {
  if (params.queryType === queryType)
    return
  params.queryType = queryType
  handleGetDatas(true)
}

function handleOnload() {
  handleGetDatas()
}

function handleDetailClose() {
  handleGetDatas(true)
}

onMounted(() => {
  // 抽屉动画/隐藏容器下 infinite-scroll 可能不触发，挂载时主动拉首屏
  handleGetDatas(true)
  bus.$on('notice:detail:close', handleDetailClose)
})

onUnmounted(() => {
  bus.$off('notice:detail:close', handleDetailClose)
})
</script>

<template>
  <div class="mb-4" style="--el-border-color: white; ">
    <el-button round plain :type="params.queryType === 'ALL' ? 'primary' : 'default'" @click="handleQueryTypeChange('ALL')">
      全部
    </el-button>
    <el-button round plain :type="params.queryType === 'UNREAD' ? 'primary' : 'default'" @click="handleQueryTypeChange('UNREAD')">
      未读
    </el-button>
    <el-button round plain :type="params.queryType === 'READ' ? 'primary' : 'default'" @click="handleQueryTypeChange('READ')">
      已读
    </el-button>
  </div>
  <el-empty v-if="!list?.length && !loading" description="暂无数据" :image-size="100" />
  <ul v-infinite-scroll="handleOnload" :infinite-scroll-disabled="finished || loading">
    <div v-for="item in list" :key="item.messageId">
      <Item :data="item" />
    </div>
  </ul>
</template>
